export default __webpack_public_path__ + "static/media/40.37fab8e1.jpg";